export const getScrollLeftAfterDelta = (left: number, delta: number) =>
  Math.max(0, left + delta)

export const getScrollLeftAfterResize = ({
  left,
  previousCellWidth,
  nextCellWidth
}: {
  left: number
  previousCellWidth: number
  nextCellWidth: number
}) => {
  if (previousCellWidth <= 0 || nextCellWidth <= 0) return left
  const firstVisibleDay = Math.round(left / previousCellWidth)
  return firstVisibleDay * nextCellWidth
}
